import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { PrimaryButton, SizeableRoundedDialog, Text, MaterialTimeInput } from 'library';
import { ILeanShift } from '../../BusinessJob/models';
import { useMediaQuery } from '@mui/material';
import theme from 'theme';
import useLoading from 'library/hooks/useLoading';
import { client } from 'shared';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { IShift, ShiftProviderUser } from 'models';

interface ClockInButtonProps {
    shift: IShift | ILeanShift;
    provider?: ShiftProviderUser;
    onComplete: () => void;
}

export default function ClockInButton({ shift, provider, onComplete }: ClockInButtonProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <PrimaryButton buttonStyle={{ width: undefined, margin: 5 }} onClick={() => setIsModalOpen(true)}>
                Clock In
            </PrimaryButton>
            <ClockInModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onComplete={() => {
                    setIsModalOpen(false);
                    onComplete();
                }}
                shift={shift}
                provider={provider}
            />
        </>
    );
}

export function ClockInModal({
    open,
    onClose,
    onComplete,
    shift,
    provider,
}: {
    open: boolean;
    onClose: () => void;
    onComplete: () => void;
    shift: IShift | ILeanShift;
    provider?: ShiftProviderUser;
}) {
    const [clockInTime, setClockInTime] = useState<Date | null | undefined>(new Date(shift.start_date));
    const [isClockInValid, setIsClockInValid] = useState(true);

    useEffect(() => {
        setClockInTime(new Date(shift.start_date));
    }, [shift.start_date]);

    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const { loading, setLoading } = useLoading();
    function submit() {
        setLoading(true);
        const clockInIsoString = clockInTime?.toISOString();

        client(`api/hour-report/clock-in/`, {
            method: 'POST',
            body: {
                appointment_id: shift.id?.toString(),
                provider_user_id: provider?.id?.toString(),
                provider_clock_in: clockInIsoString,
                business_clock_in: clockInIsoString,
                business_clocked_provider_in: clockInIsoString,
            },
        })
            .then(onComplete)
            .finally(() => {
                setLoading(false);
                close();
            });
    }

    function onClockInChange(value: MaterialUiPickersDate) {
        setIsClockInValid(value?.isValid() || false);
        setClockInTime(value?.toDate());
    }

    return (
        <SizeableRoundedDialog
            open={open}
            onClose={onClose}
            fullScreen={small}
            closeButton
            maxWidth="md"
            style={{ maxWidth: 500 }}
        >
            <Grid container item direction="column" style={{ padding: 20, gap: 10 }}>
                <Text variant="h1">Clock {provider?.first_name} in</Text>
                <Text variant="body1" bold>
                    Ensure {provider?.first_name} is clocked in by entering their arrival time below.
                </Text>
                <Grid item>
                    <MaterialTimeInput value={clockInTime} onChange={onClockInChange} label="Clock in time" />
                </Grid>
                <PrimaryButton
                    disabled={loading || !clockInTime || !isClockInValid}
                    loading={loading}
                    onClick={submit}
                    buttonStyle={{ width: undefined, alignSelf: 'flex-end' }}
                >
                    Clock In
                </PrimaryButton>
            </Grid>
        </SizeableRoundedDialog>
    );
}
